export default {
  SET_FOLDERS: (state, data) => {
    state.folders = data;
  },
  SET_FOLDER: (state, data) => {
    state.folder = data;
  },
};
